import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsPageLibrarySubNavigationItem.module.scss";
import {useSongsPageLibrarySubNavigationItemLogic} from "./SongsPageLibrarySubNavigationItem.logic";
import {isDefined} from "../../../util/is-type";

export interface ISongsPageLibrarySubNavigationItemProps {
  resultsFilterSubset?: "favorites";
  title: string;
}

export const SongsPageLibrarySubNavigationItem: VoidFunctionComponent<ISongsPageLibrarySubNavigationItemProps> = ({title, resultsFilterSubset}) => {
  const {isActive} = useSongsPageLibrarySubNavigationItemLogic(resultsFilterSubset);
  const useClasses = [
    s.navItem,
  ];
  if (isActive){
    useClasses.push(s.active);
  }
  return (
    <div className={useClasses.join(` `)}>
      <a className={s.navLink} href={`#/songs/library${isDefined(resultsFilterSubset) ? `/${resultsFilterSubset}` : ``}`} > {title} </a>
    </div>
  );
}

